const _ = require('lodash')
const Promise = require('bluebird')

// Allow this library to be loaded as a no-op on the server-side
const airbrakeClient = typeof window !== 'undefined'
  ? window.airbrake
  : undefined

module.exports = {
  configure,
  attachBuildNumber,
  addFilter,
  notify
}

function configure() {
  if (!airbrakeClient) {
    return
  }
  filterIgnorableErrors()
  registerEntrySourceMaps()
}

function addFilter(filter) {
  if (airbrakeClient) {
    airbrakeClient.addFilter(filter)
  }
}

function notify(notice) {
  if (airbrakeClient) {
    return airbrakeClient.notify(notice)
  }
  /* eslint-disable no-console */
  console.warn(`airbrake.notify fallback:`, notice)
  /* eslint-enable no-console */
  return Promise.resolve()
}

function attachBuildNumber(buildNumber) {
  addFilter(function (notice) {
    notice.buildNumber = buildNumber
    return notice
  })
}

function registerEntrySourceMaps() {
  // Provide publicly-accessible sourcemaps to Airbrake.
  // https://github.com/airbrake/airbrake-js#source-map

  const sourceMaps = {}
  const jsCdnRegex = /\.js(-[0-9a-f]+\.gz)?$/

  // `data-entry` attr is set by the `+javascript` code-loader template mixin
  $('script[data-entry]').each((index, el) => {
    const jsSrc = el.src
    sourceMaps[jsSrc] = jsSrc.replace(jsCdnRegex, '.js.map')
  })

  addFilter(function (notice) {
    notice.sourceMaps = sourceMaps
    return notice
  })
}

function filterIgnorableErrors() {
  addFilter(function (notice) {
    const [ err ] = notice.errors
    if (isIgnorableError(err) || isIgnorableBySrcAndMsgPattern(err)) {
      return null
    }
    return notice
  })
}

function isIgnorableError(error) {
  return (
    error.isIgnorable ||
    _.some(IGNORABLE_ERROR_MESSAGE_REGEXPS, re => re.test(error.message))
  )
}

function isIgnorableBySrcAndMsgPattern(error) {
  const [{ file }] = error.backtrace
  return _.some(IGNORABLE_ERRORS_BY_SRC_AND_MSG_PATTERN, ({ srcPattern, msgPattern }) => {
    return srcPattern.test(file) && msgPattern.test(error.message)
  })
}

const IGNORABLE_ERROR_MESSAGE_REGEXPS = [
  /^invalid csrf token$/,
  // Aborted requests are not really errors.
  /^XHR statusText\[abort\]/,
  // Unsent requests generally mean client-side network hiccups.
  /^XHR readyState\[UNSENT\]/,
  // Don't kick ourselves while we're down for 500+ errors on root-relative urls
  /^XHR status\[5[0-9]{2}\] for url\[\//,
  // https://mix.airbrake.io/projects/169213/groups/2124247305540325954/notices/2128664763539138338?tab=notice-detail
  /^[A-Za-z0-9]{4}\.data\.indexOf is not a function$/,
  // https://mix.airbrake.io/projects/169213/groups/2121903526460248991/notices/2159884187152807048?tab=notice-detail
  /^WeixinJSBridge is not defined$/,
  // https://mix.airbrake.io/projects/169213/groups/2121903526460248991/notices/2157080593831689968?tab=notice-detail
  /^vid_mate_check is not defined$/,
  // https://mix.airbrake.io/projects/169213/groups/2135084299090648626/notices/2147384900517570066?tab=notice-detail
  /^__show__deepen is not defined$/
]

const IGNORABLE_ERRORS_BY_SRC_AND_MSG_PATTERN = [
  {
    srcPattern: /^https:\/\/cdn.branch.io/,
    msgPattern: /^The operation is insecure\.$/
  },
  {
    srcPattern: /^chrome-extension:\/\/(?!jdgmgdpcphmdofoplgjifmdajnfojnin)/,
    msgPattern: /.*/
  },
  {
    srcPattern: /^moz-extension:\/\/(?!7217e373-875a-cc46-92ab-5b02a45c6e99)/,
    msgPattern: /.*/
  },
  {
    srcPattern: /^safari-extension:\/\//,
    msgPattern: /.*/
  },
  {
    srcPattern: /^ms-browser-extension:\/\/(?!MixTech_66E9940FB37749CAA93570AC91E08B60)/,
    msgPattern: /.*/
  }
]
